import { useContext } from "react";
import { ContainerContext, WithModalContext } from "./Context";
import { useLayoutEffect } from "./helpers";
const useModal = (config, deps = []) => {
    const { setConfig, show, state, ...withModalContext } = useContext(WithModalContext);
    const containerContext = useContext(ContainerContext);
    const hide = () => {
        withModalContext.withModal ? withModalContext.hide() : containerContext.hide();
    };
    useLayoutEffect(() => {
        if (config)
            setConfig(config);
    }, deps);
    return {
        show,
        hide,
        setConfig,
        state
    };
};
export { useModal };
